document.addEventListener("DOMContentLoaded", function () {

  const videoPlayers = document.querySelectorAll('.videoPlayer');

  videoPlayers.forEach(function (player) {
    const htmlVideo = player.querySelector('.videoPlayer__video');
    const embed = player.querySelector('.videoPlayer__embed');
    const playButton = player.querySelector('.videoPlayer__playButton');
    const overlay = player.querySelector('.videoPlayer__overlay');

    if (htmlVideo) {
      const video = htmlVideo.querySelector('video');

      // Use event delegation for better performance
      player.addEventListener('click', function (e) {
        // Prevent multiple clicks
        if (e.target.closest('.videoPlayer__playButton') || e.target.closest('.videoPlayer__overlay')) {
          if (video.paused) {
            video.play();
            video.setAttribute('controls', 'controls');
            if (playButton) playButton.style.display = 'none';
            if (overlay) overlay.style.display = 'none';
          } else {
            video.pause();
            video.removeAttribute('controls');
            if (playButton) playButton.style.display = 'block';
            if (overlay) overlay.style.display = 'block';
          }
        }
      });

      video.addEventListener('ended', function () {
        video.removeAttribute('controls');
        if (playButton) playButton.style.display = 'block';
        if (overlay) overlay.style.display = 'block';
      });
    }

    if (embed) {
      const iframe = embed.querySelector('iframe');
      if (iframe) {
        const src = iframe.getAttribute('src');

        // Only modify src if it exists
        if (src) {
          const separator = src.includes('?') ? '&' : '?';
          iframe.setAttribute('src', src + separator + 'controls=0');

          player.addEventListener('click', function () {
            iframe.setAttribute('src', src + separator + 'autoplay=1&controls=1');
            if (playButton) playButton.style.display = 'none';
            if (overlay) overlay.style.display = 'none';
          }, { once: true }); // Only trigger once
        }
      }
    }

  });

});
